module.exports = __webpack_public_path__ + "img/question.13c25178.svg";